export default "/assets/images/technology-graph-01.svg?fb6cb2c0a214042b6454129f8f42d405";